module.exports = __webpack_public_path__ + "img/portfolio.5817e09f.jpg";